import {
  getAbsoluteAssetUrl,
  getAbsoluteUrl,
  homePageMetadata,
  LearningPageKey,
  pageMetadata,
  personMetadata,
  siteMetadata,
} from "./pageMetadata";

export const socialImageUrl = getAbsoluteAssetUrl(siteMetadata.socialImagePath);

export const getHomeStructuredData = () => {
  const person = {
    "@context": "https://schema.org",
    "@type": "Person",
    "@id": `${siteMetadata.url}/#person`,
    name: personMetadata.name,
    jobTitle: personMetadata.role,
    url: siteMetadata.url,
    email: siteMetadata.contactEmail,
    telephone: siteMetadata.contactPhone,
    sameAs: siteMetadata.sameAs,
    ...(personMetadata.imagePath
      ? { image: getAbsoluteAssetUrl(personMetadata.imagePath) }
      : {}),
  };

  const organization = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "@id": `${siteMetadata.url}/#organization`,
    name: siteMetadata.organization.name,
    alternateName: siteMetadata.organization.alternateName,
    url: siteMetadata.organization.url,
    description: siteMetadata.organization.description,
    email: siteMetadata.organization.contactEmail,
    sameAs: siteMetadata.organization.sameAs,
    founder: {
      "@type": "Person",
      name: siteMetadata.organization.founder,
      jobTitle: siteMetadata.organization.founderRole,
    },
  };

  return [
    {
      "@context": "https://schema.org",
      "@type": "WebSite",
      "@id": `${siteMetadata.url}/#website`,
      url: siteMetadata.url,
      name: siteMetadata.name,
      alternateName: siteMetadata.alternateNames,
      description: siteMetadata.description,
      publisher: { "@id": `${siteMetadata.url}/#organization` },
    },
    organization,
    person,
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${siteMetadata.url}/#webpage`,
      url: siteMetadata.url,
      name: homePageMetadata.title,
      description: homePageMetadata.description,
      isPartOf: { "@id": `${siteMetadata.url}/#website` },
      about: { "@id": `${siteMetadata.url}/#person` },
    },
  ];
};

export const getLearningStructuredData = (pageKey: LearningPageKey) => {
  const page = pageMetadata[pageKey];
  const pageUrl = getAbsoluteUrl(page.path);

  return [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: siteMetadata.url,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: page.heading,
          item: pageUrl,
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name: page.title,
      description: page.description,
      isPartOf: { "@id": `${siteMetadata.url}/#website` },
      about: { "@id": `${siteMetadata.url}/#person` },
      breadcrumb: { "@id": `${pageUrl}#breadcrumb` },
    },
  ].map((item, index) =>
    index === 0 ? { ...item, "@id": `${pageUrl}#breadcrumb` } : item
  );
};

export const getLegalStructuredData = (pageKey: "privacy" | "terms") => {
  const page = pageMetadata[pageKey];
  const pageUrl = getAbsoluteUrl(page.path);

  return [
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: siteMetadata.url,
        },
        {
          "@type": "ListItem",
          position: 2,
          name: page.heading,
          item: pageUrl,
        },
      ],
    },
    {
      "@context": "https://schema.org",
      "@type": "WebPage",
      "@id": `${pageUrl}#webpage`,
      url: pageUrl,
      name: page.title,
      description: page.description,
      isPartOf: { "@id": `${siteMetadata.url}/#website` },
      about: { "@id": `${siteMetadata.url}/#organization` },
      breadcrumb: { "@id": `${pageUrl}#breadcrumb` },
    },
  ].map((item, index) =>
    index === 0 ? { ...item, "@id": `${pageUrl}#breadcrumb` } : item
  );
};
